import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to MLB.com",
    description:
      "Click Continue and connect your San Jose Giants account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your{" "}
        <Link
          target="_blank"
          href="https://mlb.tickets.com/?agency=GSJM_MYTIXX&orgid=56750#/auth/login"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          MyTickets
        </Link>{" "}
        account within 24 hours of purchase. Reach out to Live Fan Support or
        San Jose Giants Box Office at (408) 297-1435 for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the San Jose Churros Ticket Package work?",
    description:
      "The  San Jose Churros Ticket Package allows fans to select any seat to select games hosted by the San Jose Giants. Simply log into your MLB.com and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description:
      "Yes, you can choose from all currently available Box Seat inventory.",
  },
  {
    title: "Where are my tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your San Jose Giants{" "}
        <Link
          target="_blank"
          href="https://mlb.tickets.com/?agency=GSJM_MYTIXX&orgid=56750#/auth/login"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          MyTickets
        </Link>{" "}
        Account.
      </>
    ),
  },
];
